import { createContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'

import { parseConsentData } from '../utils/store/consent'

export const NavigationContext = createContext()

const NavigationProvider = (props) => {
  const { children } = props

  const router = useRouter()

  const [navScrollState, setNavScrollState] = useState(false)
  const [notificationSeen, setNotificationSeen] = useState(false)
  const [routeChange, setRouteChange] = useState(false)
  const [cardDialogIndex, setCardDialogIndex] = useState(false)
  const [toastMessage, setToastMessage] = useState(false)
  const [cookiesConsent, setCookiesConsent] = useState([])
  const [consentManagerLoaded, setConsentManagerLoaded] = useState(false)
  const [dropdownOverlay, setDropdownOverlay] = useState(false)

  const startRouteChange = () => setRouteChange(true)
  const endRouteChange = () => setRouteChange(false)
  const hasConsent = (vendor) => {
    if (typeof cookiesConsent === 'object') {
      return cookiesConsent?.includes(vendor) || cookiesConsent?.includes('all-vendors')
    } else return cookiesConsent
  }

  const updateCookiesConsent = (consentData) => {
    let consent
    if (typeof consentData === 'object') {
      consent = parseConsentData(consentData)
    } else {
      consent = consentData ? ['all-vendors'] : []
    }
    setCookiesConsent(consent)
  }

  const acceptAllCookies = () => {
    // eslint-disable-next-line no-undef
    if (typeof __cmp !== 'undefined' && process.env.NEXT_PUBLIC_CONSENT_MANAGER_ID) __cmp('setConsent', 1)
    else updateCookiesConsent(true)
  }

  const openCookieSettings = () => {
    // eslint-disable-next-line no-undef
    if (typeof __cmp !== 'undefined' && process.env.NEXT_PUBLIC_CONSENT_MANAGER_ID) __cmp('showScreenAdvanced')
  }

  useEffect(() => {
    const handleRouteChange = () => startRouteChange()
    const handleHistoryChange = () => endRouteChange()

    router.events.on('routeChangeStart', handleRouteChange)
    router.events.on('beforeHistoryChange', handleHistoryChange)

    return () => {
      router.events.off('routeChangeStart', handleRouteChange)
      router.events.off('beforeHistoryChange', handleHistoryChange)
    }
  }, [])

  return (
    <NavigationContext.Provider
      value={{
        navScrollState,
        setNavScrollState,
        routeChange,
        setRouteChange,
        cardDialogIndex,
        setCardDialogIndex,
        toastMessage,
        setToastMessage,
        cookiesConsent,
        setCookiesConsent,
        notificationSeen,
        setNotificationSeen,
        acceptAllCookies,
        openCookieSettings,
        hasConsent,
        updateCookiesConsent,
        consentManagerLoaded,
        setConsentManagerLoaded,
        dropdownOverlay,
        setDropdownOverlay
      }}
    >
      {children}
    </NavigationContext.Provider>
  )
}

NavigationProvider.propTypes = {
  children: PropTypes.object
}

export default NavigationProvider
